import { render, staticRenderFns } from "./app-event-tab.vue?vue&type=template&id=35490837&"
import script from "./app-event-tab.vue?vue&type=script&lang=js&"
export * from "./app-event-tab.vue?vue&type=script&lang=js&"
import style0 from "./app-event-tab.vue?vue&type=style&index=0&id=35490837&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports